/*
 *
 * TransactionsDownloadAllPopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 16-Jun-2025
*/

import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import formattedMessage from './languageModule'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'
import { DocumentXLS, DocumentCVS, ExclamationCircle } from '@nexidigital/iconlibrary'
import MerchantToastMessage from '@nexidigital/merchanttoastmessage'
import './TransactionsDownloadAllPopup.scss'

const TransactionsDownloadAllPopup = (props) => {
  const [downloadingFormat, setDownloadingFormat] = useState(null)

  const actionName = props.transactionType === 'accounted' ? 'doGetStartDownloadAccountedTransactions' : 'doGetStartDownloadAuthorizedTransactions'
  const payloadName = props.transactionType === 'accounted' ? 'transactionAccountedRequest' : 'transactionAuthorizedRequest'

  // Reset format download when the loading finishes
  useEffect(() => {
    if (!props.isDownloadLoading && downloadingFormat) {
      setDownloadingFormat(null)
    }
  }, [props.isDownloadLoading, downloadingFormat])

  const handleDownloadCSV = () => {
    setDownloadingFormat('CSV')

    props.actions[actionName]({
      [payloadName]: {
        startDate: props.startDate,
        endDate: props.endDate,
        filterType: props.filterType,
        customPeriod: props.customPeriod
      },
      transactionDownloadData: {
        format: 'CSV'
      }
    })
  }

  const handleDownloadExcel = () => {
    setDownloadingFormat('EXCEL')

    props.actions[actionName]({
      [payloadName]: {
        startDate: props.startDate,
        endDate: props.endDate,
        filterType: props.filterType,
        customPeriod: props.customPeriod
      },
      transactionDownloadData: {
        format: 'EXCEL'
      }
    })
  }
  return (
    <Toggle>
      <MerchantModal
        topBarTitle=' '
        onClose={() => props.actions.doHidePopup()}
        primaryAction={() => handleDownloadCSV()}
        primaryButtonLoading={props.isDownloadLoading && downloadingFormat === 'CSV'}
        primaryButtonLabel={formattedMessage.primaryButtonLabel}
        primaryIcon={<DocumentCVS size='24' type='line' />}
        primaryButtonTertiary
        secondaryAction={() => handleDownloadExcel()}
        secondaryButtonLoading={props.isDownloadLoading && downloadingFormat === 'EXCEL'}
        secondaryButtonLabel={formattedMessage.secondaryButtonLabel}
        secondaryIcon={<DocumentXLS size='24' type='line' />}
        secondaryButtonTertiary
        closeLabel={formattedMessage.close}
        title={formattedMessage.title}
        customAnalyticsDescription={formattedMessage.description}
        description={
          <><div>{formattedMessage.formatInfoMessage}</div>
            <div className='downloadMessage'>
              <MerchantToastMessage
                severity='info'
                showOnPage
                hideClose
                label={formattedMessage.description}
                icon={<ExclamationCircle size='24' type='line' />}
              />
            </div>
          </>
        }
      />
    </Toggle>
  )
}

TransactionsDownloadAllPopup.propTypes = {
  actions: PropTypes.object,
  isDownloadLoading: PropTypes.bool,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  filterType: PropTypes.object,
  pageNumber: PropTypes.number,
  pageSize: PropTypes.number,
  customPeriod: PropTypes.object,
  transactionType: PropTypes.string
}

TransactionsDownloadAllPopup.defaultProps = {
  actions: {},
  isDownloadLoading: false,
  startDate: '',
  endDate: '',
  filterType: {},
  pageNumber: 1,
  pageSize: 30,
  customPeriod: null,
  transactionType: ''
}

export default TransactionsDownloadAllPopup
